[
  {
    "minLevel": 1,
    "maxLevel": 19,
    "requirement": 5,
    "rewardGems": 200
  },
  {
    "minLevel": 20,
    "maxLevel": 49,
    "requirement": 10,
    "rewardGems": 200
  },
  {
    "minLevel": 50,
    "maxLevel": 99,
    "requirement": 15,
    "rewardGems": 200
  },
  {
    "minLevel": 100,
    "requirement": 20,
    "rewardGems": 200
  }
]
